import { Button, Grid, Loader, View, withAuthenticator, WithAuthenticatorProps } from '@aws-amplify/ui-react';

import React from 'react';
import Amplify from 'aws-amplify';
import aws_exports from './aws-exports';

import { useLoadEntries } from './components/load-entries';
import { WorkEntries } from './components/work-entries.component';
import { GitInfo } from './util/git-info.component';

import './App.css';

Amplify.configure(aws_exports);

// const userGroups = user.getSignInUserSession()?.getAccessToken().payload['cognito:groups'];
// console.log(userGroups);

export const App = withAuthenticator(
    ({ user, signOut }: WithAuthenticatorProps) => {
        if (user == null) {
            return null;
        }

        const loadedMonths = useLoadEntries();
        const overTime = loadedMonths?.reduce((p, c) => p + (c.workHours - c.requiredHours), 0) ?? 0;

        return (
            <Grid columnGap="0.5rem" rowGap="0.5rem" templateColumns="5fr 1fr" templateRows="1fr 10fr 1fr" height="100%">
                <View columnSpan={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 25 }}>
                    VT{' '}
                    <span style={{ color: overTime >= 0 ? 'green' : 'red', paddingLeft: 8 }}>
                        {overTime >= 0 ? '+' : ''}
                        {overTime}
                    </span>
                </View>
                <View columnSpan={2}>{loadedMonths == null ? <Loader size="large" /> : <WorkEntries loadedMonths={loadedMonths} />}</View>
                <View style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid', margin: 8 }}>
                    <GitInfo />
                </View>
                <View style={{ display: 'flex', alignItems: 'center' }}>
                    <Button isFullWidth variation="primary" onClick={signOut} style={{ display: 'flex' }}>
                        Sign out
                    </Button>
                </View>
            </Grid>
        );
    },
    { hideSignUp: true }
);
